<button
  type="button"
  class="eventq-flag-alarm-toggle"
  [class.eventq-flag-alarm-toggle--active]="flagged()"
  [attr.aria-pressed]="flagged()"
  [attr.aria-label]="flagged() ? 'Unflag alarm' : 'Flag alarm'"
  (click)="toggle()"
>
  <img
    class="eventq-flag-alarm-toggle__icon"
    [src]="(flagged() ? '/assets/events/icons/flag-pennant-active.svg' : '/assets/events/icons/flag-pennant.svg') | prefixUrl"
    alt=""
  />
</button>
